import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeyClickService {
  pressedKeys: { [key: string]: boolean } = {};
  constructor() {}

  handleKeyClick(event: KeyboardEvent) {
    if (!(event.key in this.pressedKeys)) {
      this.pressedKeys[event.key] = true;
    }
  }

  handleKeyClickUp(event: KeyboardEvent) {
    delete this.pressedKeys[event.key];
  }

  clickedKey(key: string) {
    return key in this.pressedKeys;
  }

  /**
   * Return true if either the Control+Enter, Meta+Enter, or Control+Space shortcut was pressed
   *
   * @return {*}  {boolean}
   * @memberof KeyClickService
   */
  hasSendAndNewShortcut(): boolean {
    console.log('Keyclick service pressed keys', this.pressedKeys);
    return (
      ('Control' in this.pressedKeys && 'Enter' in this.pressedKeys) ||
      ('Meta' in this.pressedKeys && 'Enter' in this.pressedKeys) ||
      ('Control' in this.pressedKeys && ' ' in this.pressedKeys)
    );
  }
}
